"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FestivalSuccessCommand = void 0;
const AbstractCommand_1 = require("./AbstractCommand");
class FestivalSuccessCommand extends AbstractCommand_1.AbstractCommand {
    constructor(input) {
        super(input);
        this.input = input;
    }
    execute(config) {
        return this.getCommandService(config).doTrackFestivalSuccessEvent(this.input);
    }
}
exports.FestivalSuccessCommand = FestivalSuccessCommand;
